import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

const store = new vuex.Store ({
  state: {
      active: 1,
      isMB: document.body.offsetWidth < 768
  },
  mutations: {
    change (state, page) {
      state.active = page
    //   console.log(page)
    }
  },
  actions: {
    changeActive (context, page) {
      context.commit("change", page)
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js